import { render, staticRenderFns } from "./setChartStyle-editor.vue?vue&type=template&id=9abfc232&scoped=true"
import script from "./setChartStyle-editor.vue?vue&type=script&lang=js"
export * from "./setChartStyle-editor.vue?vue&type=script&lang=js"
import style0 from "./setChartStyle-editor.vue?vue&type=style&index=0&id=9abfc232&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9abfc232",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9abfc232')) {
      api.createRecord('9abfc232', component.options)
    } else {
      api.reload('9abfc232', component.options)
    }
    module.hot.accept("./setChartStyle-editor.vue?vue&type=template&id=9abfc232&scoped=true", function () {
      api.rerender('9abfc232', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/dashboard-design/charts/property-editor/setChartStyle-editor.vue"
export default component.exports